// extracted by mini-css-extract-plugin
export var header = "RelateArticles-module--header--4d8f0";
export var relatedArticlesWrapper = "RelateArticles-module--related-articles-wrapper--0b70c";